/* @flow */

/* TODO: Resolve this! $FlowFixMe */
import actionTypes, { Type } from '../actions/types';

export const THEME_DARK = 'DARK';
export const THEME_LIGHT = 'LIGHT';

export const INITIAL_STATE = {
  theme: THEME_LIGHT,
};

export const reducer = (state: Object, action: Type) => {
  switch (action.type) {
    case actionTypes.SET_THEME:
      return { ...state, theme: action.data };
    default:
      return state;
  }
};
